import React, { useEffect, useState } from "react";
import {
  MapContainer as LeafletContainer,
  TileLayer,
  useMap
} from "react-leaflet";
import { Box } from "@material-ui/core";

import DeviceMarker from "./DeviceMarker";
import MapLegend from "./MapLegend";

const mapOptions = {
  center: [51.1657, 10.4515],
  zoom: 6,
  scrollWheelZoom: true,
  style: { height: "100%", width: "100%" }
};

// Leaflet measures its container on mount need an explicit invalidateSize().
const MapSizeHandler = () => {
  const map = useMap();

  useEffect(() => {
    map.invalidateSize();

    const handleResize = () => map.invalidateSize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [map]);

  return null;
};

const DeviceMarkers = ({ devices, highlightedDevice, sensorSettings }) => {
  const map = useMap();
  // Initialized from highlightedDevice so a marker opened via a deep link
  // from device/infobar starts in the same pinned/clicked state as a manual click.
  const [pinnedDeviceId, setPinnedDeviceId] = useState(
    highlightedDevice ? highlightedDevice.id : null
  );

  useEffect(() => {
    if (!highlightedDevice) {
      return;
    }

    map.setView(
      {
        lng: highlightedDevice.location.lng,
        lat: highlightedDevice.location.lat
      },
      12
    );
  }, [highlightedDevice, map]);

  const handlePin = deviceId => setPinnedDeviceId(deviceId);
  const handleUnpin = deviceId =>
    setPinnedDeviceId(prev => (prev === deviceId ? null : prev));

  return (
    <>
      {devices.map(device => (
        <DeviceMarker
          key={device.id}
          device={device}
          isHighlighted={device === highlightedDevice}
          sensorSettings={sensorSettings}
          pinnedDeviceId={pinnedDeviceId}
          onPin={handlePin}
          onUnpin={handleUnpin}
        />
      ))}
    </>
  );
};

const Map = ({
  devices,
  filteredDevices,
  highlightedDevice,
  sensorSettings,
  selectedStatuses,
  onToggleStatus,
  onReset
}) => {
  return (
    <Box position="relative" flex="1 1 auto">
      <LeafletContainer {...mapOptions}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MapSizeHandler />
        <DeviceMarkers
          devices={filteredDevices}
          highlightedDevice={highlightedDevice}
          sensorSettings={sensorSettings}
        />
      </LeafletContainer>
      <MapLegend
        devices={devices}
        selectedStatuses={selectedStatuses}
        onToggleStatus={onToggleStatus}
        onReset={onReset}
      />
    </Box>
  );
};

export default Map;
